import "./EmailIntegration.scss"

import { FooterVariant, Tile } from "@skylead/component-library"
import React, { useEffect } from "react"
import { useDispatch } from "react-redux"

import {
  clearFormErrors,
  closeModal as closeModalAction,
  showModal,
  updateFormFields,
} from "../../../redux/actions"
// eslint-disable-next-line import/no-cycle
import { onSmtpSubmit, resetCustomSMTPFormData } from "../../../utils/email-account-utils"
import { useConfig, useGlobalTranslation } from "../../../utils/hook"
import EmailIntegrationBody from "../../atoms/EmailIntegrationBody"
import { ModalVariant } from "../../atoms/Modal"

const EmailIntegration = ({
  type = "gmail",
  title = "",
  accountID,
  userID,
  noRightMargin = false,
}) => {
  const dispatch = useDispatch()
  const { tt } = useGlobalTranslation()

  const config = useConfig()

  useEffect(() => {
    const initializeData = () => {
      dispatch(
        updateFormFields({
          smtpSsl: true,
          smtpTest: null,
          imapTest: null,
          loadingSmtp: false,
          loadingImap: false,
        }),
      )
    }
    initializeData()
  }, [])

  const provider = React.useMemo(
    () =>
      ({
        gmail: "Gmail",
        outlook: "Outlook",
        smtp: "Custom SMTP server",
      }[type]),
    [type],
  )

  const icon = React.useMemo(
    () =>
      ({
        gmail: "gmail",
        "custom-gmail": "gmail",
        outlook: "outlook",
        "custom-outlook": "outlook",
        smtp: "smtp",
      }[type]),
    [type],
  )

  const openConnectLink = () => {
    window.open(
      `${config.REACT_APP_BACKEND_URL}/users/${userID}/accounts/${accountID}/oauth_email/authenticate?type=${type}&accountId=${accountID}`,
      "_self",
    )
  }

  /* eslint-disable no-use-before-define */
  const emailProviderConnect = () => {
    dispatch(clearFormErrors())
    resetCustomSMTPFormData()
    dispatch(closeModalAction())
  }

  /* eslint-disable no-use-before-define */
  const smtpTemplateModal = async templateType => {
    dispatch(clearFormErrors())
    resetCustomSMTPFormData()
    dispatch(closeModalAction())

    if (templateType === "Gmail") {
      dispatch(
        updateFormFields({
          "smtp-ip": "smtp.gmail.com",
          "smtp-port": "587",
          "imap-ip": "imap.gmail.com",
          "imap-port": "993",
          smtpSsl: true,
        }),
      )
    } else if (templateType === "Outlook") {
      dispatch(
        updateFormFields({
          "smtp-ip": "smtp.office365.com",
          "smtp-port": "587",
          "imap-ip": "outlook.office365.com",
          "imap-port": "993",
          smtpSsl: true,
        }),
      )
    } else if (templateType === "Yahoo") {
      dispatch(
        updateFormFields({
          "smtp-ip": "smtp.mail.yahoo.com",
          "smtp-port": "465",
          "imap-ip": "imap.mail.yahoo.com",
          "imap-port": "993",
          smtpSsl: true,
        }),
      )
    } else if (templateType === "Custom") {
      dispatch(
        updateFormFields({
          "smtp-ip": "",
          "smtp-port": "",
          "imap-ip": "",
          "imap-port": "",
        }),
      )
    }

    let smtpServerName
    if (templateType !== "Custom") {
      smtpServerName = templateType
    } else {
      smtpServerName = ""
    }

    const integrationType = "connect"

    dispatch(
      showModal(
        ModalVariant.LARGE,
        `${tt("email.integration.smtp.modal.label", { action: smtpServerName })} `,
        <EmailIntegrationBody integrationType={integrationType} />,
        FooterVariant.TRANSACTIONAL,
        { label: tt("save"), onClick: () => onSmtpSubmit(tt, integrationType, userID, accountID) },
        { label: tt("cancel"), onClick: emailProviderConnect },
        undefined,
        true,
      ),
    )
  }

  const authenticate = () => {
    if (type === "gmail") {
      openConnectLink()
    } else if (type === "outlook") {
      openConnectLink()
    } else if (type === "smtp") {
      smtpTemplateModal("Custom")
    } else if (type === "custom-gmail") {
      smtpTemplateModal("Gmail")
    } else if (type === "custom-outlook") {
      smtpTemplateModal("Outlook")
    }
  }

  return (
    <Tile
      emailIntegration
      onClick={authenticate}
      icon={icon}
      text={provider}
      title={title}
      noRightMargin={noRightMargin}
    />
  )
}

// EmailIntegration.propTypes = {
//   type: PropTypes.oneOf(["gmail", "outlook", "custom-gmail", "custom-outlook", "smtp"]),
//   title: PropTypes.string,
//   accountID: PropTypes.number.isRequired,
//   userID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
//   noRightMargin: PropTypes.bool,
// }

export default React.memo(EmailIntegration)
